import { render } from "./ProdTest.vue?vue&type=template&id=7dc2d488"
import script from "./ProdTest.vue?vue&type=script&lang=js"
export * from "./ProdTest.vue?vue&type=script&lang=js"

import "./ProdTest.vue?vue&type=style&index=0&id=7dc2d488&lang=css"
script.render = render

export default script